var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintWhite = function SvgPrintWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9h23v8H0zM4 0h15v7H4zM0 5h2v4H0zM21 5h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16h2v5H3zM18 16h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h17v2H3z"
  }))));
};
export default SvgPrintWhite;